import moment from 'moment';
import React from 'react'
import { Table } from 'react-bootstrap'
import ViewEnrollmentModal from '../Modals/ViewEnrollment.modal';
import { FaEye } from 'react-icons/fa';

interface IReporting {
    tableData: any;
    reloadData: any;
}

const ReportingTable = (props: IReporting) => {

    const [viewEnrollment, setViewEnrollment] = React.useState<any>(undefined);

    return (
        <>
            <Table bordered hover responsive size='sm'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Enrollment Id</th>
                        <th>Student</th>
                        <th>Receipt Id</th>
                        <th>Teacher Name</th>
                        <th>Date of Payment</th>
                        <th>Instrument</th>
                        <th>Sessions Bought</th>
                        <th>Sessions Left</th>
                        <th>Sessions Requested</th>
                        <th>Sessions Completed</th>
                        <th>Expiry Date</th>
                        <th>Expiry Status</th>

                    </tr>
                </thead>
                <tbody>
                    {props.tableData && props.tableData.length>0 
                        ? props.tableData.map((data:any, index: number) => {
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                    <td > <div onClick={() => setViewEnrollment(data.enrollment_id)}>
                                        {data.enrollmentId} <FaEye className='text-primary ms-1' />
                                        </div></td>
                                    <td><div>
                                        {data.studentName}
                                        <br />
                                        {data.studentEmail}
                                        <br />
                                        {data.studentPhone}
                                        </div>
                                    </td>
                                    <td>{data.paymentDetailsReceipt}</td>
                                    <td>{data.instructorName}</td>
                                    <td>{data.dateOfPurchase ? moment(data.dateOfPurchase).format("DD-MM-YYYY") : '--'}</td>
                                    <td>{data.instrument}</td>
                                    <td>{data.totalClasses}</td>
                                    <td>{data.classesLeft}</td>
                                    <td>{data.classesRequested}</td>
                                    <td>{data.classesCompleted}</td>
                                    <td>{data.validityDate ? moment(data.validityDate).format("DD-MM-YYYY") : '--'}</td>
                                    <td>{data.expiryStatus}</td>
                                </tr>
                            )
                        })
                        :
                        <tr className='text-center'>
                            <td colSpan={16}> No data found </td>
                        </tr>
                    }
                </tbody>
            </Table>

            <ViewEnrollmentModal
                show={viewEnrollment}
                handleClose = { () => setViewEnrollment(undefined) }
            />
        </>
    )
}

export default ReportingTable